/*
 * @Description:
 * @Author: rqcheng
 * @Date: 2025-06-05 16:49:16
 * @LastEditors: rqcheng
 * @LastEditTime: 2025-06-20 14:43:43
 */
import Vue from "vue";
import Emit from "./emit";
import auth from "./auth";
import filter_rules from "@/utils/filter_rules";

Vue.prototype.filter_rules = filter_rules;
Vue.use(Emit);



// WEBPACK FOOTER //
// ./src/plugins/index.js